import { render, staticRenderFns } from "./CallAddMinutes.vue?vue&type=template&id=8c4764c0&"
import script from "./CallAddMinutes.vue?vue&type=script&lang=js&"
export * from "./CallAddMinutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports